import { IBackendServers, Languages } from '../../interfaces/common'

export const CrmBackendServers: IBackendServers = {
  [Languages.RU]: 'crmBackendServerRu',
  [Languages.KZ]: 'crmBackendServerKz',
  [Languages.UZ]: 'crmBackendServerUz',
}
